// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Money20 from './Money20.tsx';
import Money20Circle from './Money20Circle.tsx';
import Money24 from './Money24.tsx';
import Money24Circle from './Money24Circle.tsx';
import Money40 from './Money40.tsx';
import Money48 from './Money48.tsx';

type MoneyProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Money20,
    Money20Circle,
    Money24,
    Money24Circle,
    Money40,
    Money48,
};

const Money: FC<MoneyProps> = ({ variation, ...props }) => {
    const variationKey = `Money${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Money" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Money;
